var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 1.66663C14.6017 1.66663 18.3327 5.39759 18.3327 9.99996C18.3327 14.6023 14.6017 18.3333 9.99935 18.3333C5.39698 18.3333 1.66602 14.6023 1.66602 9.99996C1.66602 5.39759 5.39698 1.66663 9.99935 1.66663ZM6.07706 6.07767C6.37783 5.7769 6.84972 5.75376 7.17682 6.00826L7.25539 6.07767L9.99956 8.82183L12.7437 6.07767C13.0696 5.75183 13.5962 5.75183 13.9221 6.07767C14.2228 6.37844 14.246 6.85033 13.9915 7.17743L13.9221 7.256L11.1779 10.0002L13.9221 12.7443C14.2479 13.0702 14.2479 13.5968 13.9221 13.9227C13.7596 14.0852 13.5462 14.1668 13.3329 14.1668C13.1551 14.1668 12.9773 14.1101 12.829 13.9972L12.7437 13.9227L9.99956 11.1785L7.25539 13.9227C7.09289 14.0852 6.87956 14.1668 6.66622 14.1668C6.45289 14.1668 6.23956 14.0852 6.07706 13.9227C5.77629 13.6219 5.75315 13.15 6.00765 12.8229L6.07706 12.7443L8.82122 10.0002L6.07706 7.256C5.75122 6.93017 5.75122 6.4035 6.07706 6.07767Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconGray);
export default __webpack_public_path__ + "static/media/close-icon-gray.36db78cc.svg";
export { ForwardRef as ReactComponent };